import { camelCase } from 'lodash';

export const editSegmentDecompiler = (actionOptions, actionType) => {

    return {
        segmentActionType: camelCase(actionType),
        segmentId: actionOptions?.segment_id,
    }
};
